

  sliderInit();
  
function sliderInit() {
  let featuredCollectionSlider;
  featuredCollectionSlider = new Flickity(".featured-carousel", {
    selectedAttraction: 0.12,
    friction: 0.9,
    imagesLoaded: true,
    groupCells: "100%",
    cellAlign: "left",
    prevNextButtons: true,
    wrapAround: false,
    pageDots: false,
    resize: true,
  });
  featuredCollectionSlider.resize();


  // resizing for full width cards
  const sliderCards = document.querySelectorAll(
    ".featured-carousel .carousel-cell"
  );
  
  const sliderCardsWrappers = document.querySelectorAll(
    ".featured-carousel .carousel-cell .card-wrapper"
  );

  sliderCards.forEach((card) => {
    card.style.height = "100%";
  });
  sliderCardsWrappers.forEach((card) => {
    card.style.height = "100%";
  });

  window.addEventListener("resize", (event) => {
    sliderCards.forEach((card) => {
      card.style.height = "fit-content";
    });
    sliderCardsWrappers.forEach((card) => {
      card.style.height = "fit-content";
    });
    featuredCollectionSlider.resize();
    sliderCards.forEach((card) => {
      card.style.height = "100%";
    });
    sliderCardsWrappers.forEach((card) => {
      card.style.height = "100%";
    });
  });
}
